import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';

import * as Api from '../../../api/api';

export const addEmployeeMessageTemplate = (orgId: number, template: EmployeeMessageTemplate) =>
  createGenericDispatcher({
    name: 'ADD_EMPLOYEE_MESSAGE_TEMPLATE',
    loadFunction: () =>
      Api.post(`/org/${orgId}/message-templates`, {
        body: JSON.stringify(template),
      }),
    args: { orgId },
  });
